import { Canvas } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";
import { useContext } from "react";
import StateContext from "./Context/StateContext";
import Chains from "./utils/ReactSubComp/Chains";
import MyTextComponent from "./utils/ReactSubComp/TextComponent";

import goldPrizeCalculator from "./utils/goldPlateUtils";
import Dimension from "./Components/dimension/Dimension";
import { Camera } from "./Camera/Camera";
import { Effects } from "./Effects/Effects";
import { Env } from "./Env/Env";
import { CharmStone } from "./utils/ReactSubComp/CharmStone";
import { AddCharms } from "./utils/ReactSubComp/AddCharms";
import { AddDotDiamond } from "./utils/ReactSubComp/AddDotDiamond";
export default function CanvasContainer() {
    const globalState = useContext(StateContext);
    const { materials } = useGLTF(
        `${process.env.PUBLIC_URL}/assets/glbs/monkeyFace.gltf`
    );
    if (globalState.globalMaterial == null) {
        globalState.globalMaterial = materials;
    }

    const cameraPosX = goldPrizeCalculator.getPWidth() / 2;
    const cameraPosY = -goldPrizeCalculator.getPHeight() / 2;
    return (
        <>
            <Canvas
                camera={{ position: [cameraPosX, cameraPosY, 70], fov: 45 }}
                gl={{ preserveDrawingBuffer: true, powerPreference: "default" }}
                id="canvas3D"
                onCreated={({ camera }) => {
                    globalState.cameraRef.current = camera;
                }}
            >
                <Camera />
                <color attach="background" args={["#E7E7E7"]} />

                <Env />
                <MyTextComponent />

                <CharmStone />

                <Chains />

                <AddCharms />
                <AddDotDiamond />
                <Effects />
                {globalState.showDimension && <Dimension />}
            </Canvas>
        </>
    );
}
